import { Link } from 'found';
import React from 'react';
import { useIntl } from 'react-intl';
import { ButtonGroup, ButtonToolbar } from 'reactstrap';

/**
 * AdminUserControls provides the user controls for the admin/users page.
 * Surfaces paths to invite new customer and admin users.
 * @returns {React.ReactComponentElement} - AdminUserControls component
 */
function AdminUserControls() {
  const intl = useIntl();

  // Button labels
  const inviteCustomerLabel = intl.formatMessage({ id: 'admin.admin_user.admin_user_controls.invite_customer.label', defaultMessage: 'Invite customer' });
  const inviteAdminLabel = intl.formatMessage({ id: 'admin.admin_user.admin_user_controls.invite_admin.label', defaultMessage: 'Invite admin' });

  return (
    <ButtonToolbar>
      <ButtonGroup className="ms-2">
        <Link
          to="/admin/users/invite/customer"
          className="btn btn-darken"
        >
          {inviteCustomerLabel}
        </Link>
        <Link
          to="/admin/users/invite/admin"
          className="btn btn-darken"
        >
          {inviteAdminLabel}
        </Link>
      </ButtonGroup>
    </ButtonToolbar>
  );
}

export default AdminUserControls;
